import script from "./TheSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSettings.vue?vue&type=script&setup=true&lang=js"

import "./TheSettings.vue?vue&type=style&index=0&id=920bda5c&scoped=true&lang=css"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-920bda5c"]])

export default __exports__